
import React, { useEffect, useMemo, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { FaBus } from 'react-icons/fa'
import { LuGraduationCap } from 'react-icons/lu'
import SelectableField from './commonComponents/SelectableField'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import {  Form } from "react-bootstrap";
import axios from 'axios'
import Cookies from 'js-cookie'
import { BASE_URL } from './commonComponents/ApiEndpoints'
import { BsFunnelFill } from 'react-icons/bs'
import { BsSearch } from 'react-icons/bs'
import { BsArrowClockwise } from 'react-icons/bs'
import {Row,Col} from 'react-bootstrap'
import { useRef } from 'react'


export default function ViewBusAssignedStudent() {
  const [search, setSearch] = useState('')
  const { busId } = useParams()
  const location = useLocation()
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();


  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(false)
  const [busInfo, setBusInfo] = useState(null)
  const [busInfoLoading, setBusInfoLoading] = useState(false)


const [showEditModal, setShowEditModal] = useState(false);
const [selectedBus, setSelectedBus] = useState(null);
  const [mode, setMode] = useState(""); // "view" or "edit"

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
 

// search pagination 
const [itemsPerPage, setItemsPerPage] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
const [showFilterCard, setShowFilterCard] = useState(false);
const [selectedCourse, setSelectedCourse] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
        const [selectedStudentId, setSelectedStudentId] = useState('');


        // search

        const [resetKey, setResetKey] = useState(0);
const [data, setData] = useState([]);
const noopSetData = () => {};

const [user, setUser] = useState(null);
const [userRole, setUserRole] = useState([]);

const tableRef = useRef(null);

useEffect(() => {
  const userCookie = Cookies.get('user');

  if (userCookie) {
    try {
      const parsedUser = JSON.parse(userCookie);

      setUser(parsedUser);
      setUserRole(parsedUser); // roles inside same object

    } catch (err) {
      console.error("Error parsing user cookie", err);
    }
  }
}, []);



// const handleSelect = (values) => {
//   console.log("Selected Filter:", values);

//   setSelectedCourse(values.course || "");
//   setSelectedClass(values.class || "");
//   setSelectedStudentId(values.student || "");

  
// };


const handleSelect = (values) => {
  console.log("Selected Filter:", values);

  setSelectedCourse(values.course || "");
  setSelectedClass(values.class || "");
  setSelectedStudentId(values.student || "");

  let filtered = [...students];

  if (values.course) {
    filtered = filtered.filter(
      (s) => s.course_id === Number(values.course)
    );
  }

  if (values.class) {
    filtered = filtered.filter(
      (s) => s.class_id === Number(values.class)
    );
  }

  if (values.student) {
    const isNumeric = /^\d+$/.test(values.student);
    if (isNumeric) {
      filtered = filtered.filter((s) => s.id === Number(values.student));
    } else {
      filtered = filtered.filter((s) =>
        s.name?.toLowerCase().includes(values.student.toLowerCase())
      );
    }
  }

  setData(filtered);
  setCurrentPage(1);
};




  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1
        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])



useEffect(() => {
  if (busId) fetchStudentsByBus()
}, [busId])

const fetchBusDetails = async () => {
  if (!busId) return
  setBusInfoLoading(true)
  try {
    const instituteId = Cookies.get('institute_id')
    const user = JSON.parse(Cookies.get('user') || '{}')
    const res = await axios.get(`${BASE_URL}/transport/${busId}`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
        'Institute-Id': Number(instituteId)}})
    const raw = res.data?.data ?? res.data
    const info =
      raw && typeof raw === 'object' && !Array.isArray(raw)
        ? raw
        : Array.isArray(raw)
          ? raw[0]
          : null
    setBusInfo(info || null)
  } catch (err) {
    console.error(err)
  } finally {
    setBusInfoLoading(false)
  }
}

useEffect(() => {
  if (!busId) return
  const passed = location.state?.bus
  if (passed && String(passed.bus_id) === String(busId)) {
    setBusInfo(passed)
  } else {
    setBusInfo(null)
    // If no bus payload was passed from the previous page, fetch bus details.
    // This avoids unnecessary `/transport/:id` calls (and 401s for attendant users).
    fetchBusDetails()
  }
}, [busId])

useEffect(() => {
  // Always reset local filter state when opening/reloading this page
  setSelectedCourse("");
  setSelectedClass("");
  setSelectedStudentId("");
  setSearch("");
  setCurrentPage(1);
  setResetKey((prev) => prev + 1);
}, [busId]);

const fetchStudentsByBus = async () => {
  setLoading(true)
  try {
    const instituteId = Cookies.get('institute_id')
    const user = JSON.parse(Cookies.get('user') || '{}')

    const res = await axios.get(
      `${BASE_URL}/transport/${busId}/students`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
          'Institute-Id': Number(instituteId)}}
    )

    console.log("Students:", res.data)

    setStudents(res.data?.data || [])
    setData(res.data?.data || [])
  } catch (err) {
    console.error(err)
    setStudents([])
  } finally {
    setLoading(false)
  }
}

 const filteredStudents = useMemo(() => {
  if (!search.trim()) return data;

  return data.filter((s) =>
    s.name?.toLowerCase().includes(search.toLowerCase()) ||
    s.phone?.toString().includes(search) ||
    s.address?.toLowerCase().includes(search.toLowerCase())
  );
}, [data, search]);



const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentStudents = filteredStudents.slice(
  indexOfFirstItem,
  indexOfLastItem
);


useEffect(() => {
  setCurrentPage(1);
}, [search, itemsPerPage]);




const handleRefresh = () => {
    // clear selected filters
    setSelectedCourse("");
    setSelectedClass("");
    setSelectedStudentId("");
    setSearch("");
    setResetKey(prev => prev + 1); // ✅ IMPORTANT
    // reload all parents
    fetchStudentsByBus();
    fetchBusDetails();
  };


  const handleViewStudent = (id) => {
  navigate(`/student/profile/${id}`);
};


  return (
    <>
      <style>
        {`
          .page-title {
            font-family: 'Inter', system-ui, sans-serif;
            letter-spacing: -0.02em;
            color: #223843;
          }
          .modern-card {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            overflow: visiable;
          }
          /* Match CreateNotification.js premium table behavior */
          .table td {
            overflow: visible !important;
            user-select: text;
          }
          .table tbody tr {
            overflow: visible !important;
            cursor: default;
          }
          .table-card {
            overflow: visible !important;
          }
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }
          .table td, .table th { user-select: text; }

          /* Dropdown menu over table (like AddGuardian.js) */
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          .table td {
            overflow: visible !important;
          }
          .table tbody tr {
            overflow: visible !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                gap: '12px'}}
            >
              <div
                className="d-flex align-items-center gap-3"
                style={{ flex: 1, minWidth: 0 }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0}}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <h3
                    className="m-0 fw-bold page-title text-start"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                      lineHeight: '1.2'}}
                  >
                    Vehicle Assigned Student
                  </h3>
                  <p
                    className="m-0 mt-0 text-start"
                    style={{
                      fontSize: isMobile ? '10px' : '13px',
                      color: '#6b7280',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: isMobile ? 'normal' : 'nowrap'}}
                  >
                    {busInfoLoading && !busInfo
                      ? 'Loading transport details…'
                      : busInfo
                        ? `No. ${busInfo.bus_number || '—'} · Driver: ${busInfo.driver_name || '—'}`
                        : 'View and manage Vehicle.'}
                  </p>
                </div>

              </div>

              {!isMobile && (
                <div className="d-flex align-items-center gap-3" style={{ justifyContent: 'flex-end' }}>
                  <ProfileDropdown
                    logout={logout}
                    notificationCount={3}
                    showNotifications={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <Container
          fluid
          className="p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {(busInfo || busInfoLoading) && (
            <Card
              className="modern-card mb-4"
              style={{
                border: '1px solid #D1D3D4',
                borderRadius: '12px',
                background: '#f8fafc'}}
            >
              <Card.Body className="py-3 px-3 px-md-4">
                <div className="d-flex align-items-start gap-3">
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0}}
                  >
                    <FaBus size={20} color="#fff" />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      className="fw-semibold"
                      style={{ color: '#223843', fontSize: isMobile ? '15px' : '17px' }}
                    >
                      {busInfoLoading && !busInfo
                        ? 'Loading transport…'
                        : `Transport ${busInfo?.bus_number || `#${busId}`}`}
                    </div>
                    {busInfo && (
                      <Row className="g-2 mt-2 small text-muted">
                        <Col xs={12} sm={6} md={3}>
                          <span className="text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.04em' }}>
                            Driver
                          </span>
                          <div className="text-dark fw-medium" style={{ fontSize: '13px' }}>
                            {busInfo.driver_name || '—'}
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                          <span className="text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.04em' }}>
                            Contact
                          </span>
                          <div className="text-dark fw-medium" style={{ fontSize: '13px' }}>
                            {busInfo.driver_contact_number || '—'}
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                          <span className="text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.04em' }}>
                            Owner
                          </span>
                          <div className="text-dark fw-medium" style={{ fontSize: '13px' }}>
                            {busInfo.bus_owner_name || '—'}
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                          <span className="text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.04em' }}>
                            Transport ID
                          </span>
                          <div className="text-dark fw-medium" style={{ fontSize: '13px' }}>
                            {busInfo.bus_id ?? busId}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          )}

                        <div className="d-flex justify-content-between align-items-center mb-4">

                        {/* <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4"> */}
                      
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-center gap-3">
                        
                        {/* Show Per Page */}
                        <div 
                          className="d-flex align-items-center"
                          style={{
                            backgroundColor: '#ffffff',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            gap: '8px',
                            border: '1px solid #D1D3D4'}}
                        >
                          <span style={{ fontSize: '13px', color: '#6b7280' }}>
                            Show:
                          </span>
                    
                          <Form.Select
                            value={itemsPerPage}
                            onChange={(e) => {
                              setItemsPerPage(parseInt(e.target.value))
                              setCurrentPage(1)
                            }}
                            style={{
                              height: '36px',
                              fontSize: '13px',
                              borderRadius: '6px'}}
                          >
                            <option value="10">10 per page</option>
                            <option value="20">20 per page</option>
                            <option value="30">30 per page</option>
                          </Form.Select>
                        </div>
                    
                        {/* Filter Button */}
                        <button
                          onClick={() => setShowFilterCard(!showFilterCard)}
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                            border: '1px solid #D1D3D4',
                            color: showFilterCard ? '#ffffff' : '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'}}
                        >
                          <BsFunnelFill size={18} />
                        </button>
                    
                      </div>
                    
                      {/* RIGHT SIDE */}
                      <button
                        
                        style={{
                          borderRadius: '10px',
                          padding: '6px 12px',
                          height: '44px',
                          border: 'none',
                          backgroundColor: '#223843',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <FaBus size={18} />
                        <span style={{ fontSize: '12px', fontWeight: '600' }}>
                           {loading
                               ? 'Loading...'
                                : `Total Students: ${filteredStudents.length}`}
                        </span>
                      </button>
                    
                    </div>
                    
                    
                             
                                                
                            
                                          
                                             {/* Modern Filter Section */}
                                                    <div 
                                                      style={{
                                                        maxHeight: showFilterCard ? '1000px' : '0',
                                                        overflow: showFilterCard ? 'visible' : 'hidden',
                                                        transition: 'max-height 0.3s ease-in-out',
                                                        marginBottom: showFilterCard ? '24px' : '0'}}
                                                    >
                                                      {showFilterCard && (
                                                        
                                                        <Card 
                                                          style={{
                                                            border: '1px solid #D1D3D4',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#ffffff',
                                                            overflow: 'visible'}}
                                                        >
                                                          {/* Header */}
                                                          <div 
                                                            style={{
                                                              background: '#ffffff',
                                                              padding: '20px',
                                                              borderBottom: '1px solid #F3F4F6'}}
                                                          >
                                               
                                                            <div className="d-flex justify-content-between align-items-center">
                                                              <div className="d-flex align-items-center gap-3">
                                                                <div 
                                                                  style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#223843',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'}}
                                                                >
                                                                  <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                                                                </div>
                                                                <div>
                                                                  <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                                    Search Transport
                                                                  </h5>
                                                                  <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                                                                    Find quickly by name, phone, or email
                                                                  </p>
                                                                </div>
                                                              </div>
                                                              
                                                              <div className="d-flex gap-2">
                                                                <button
                                                                  onClick={handleRefresh}
                                                                  style={{
                                                                    width: '48px',
                                                                    height: '48px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#223843',
                                                                    border: 'none',
                                                                    color: '#ffffff',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s ease'}}
                                                                  onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = '#223843'
                                                                    e.currentTarget.style.transform = 'scale(1.05)'
                                                                  }}
                                                                  onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = '#223843'
                                                                    e.currentTarget.style.transform = 'scale(1)'
                                                                  }}
                                                                  title="Refresh"
                                                                >
                                                                  <BsArrowClockwise size={20} />
                                                                </button>
                                                              </div>
                                                            </div>
                                                          </div>

                                             <Card.Body ref={tableRef} className="p-4" style={{ backgroundColor: '#ffffff' }}>
                                              <Row className="g-4 text-start">
                                                
                                                {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                                                  <Col xs={12}>
                                                    <div style={{ 
                                                      padding: '20px', 
                                                      backgroundColor: '#F3F4F6', 
                                                      borderRadius: '8px',
                                                      border: '1px solid #D1D3D4'}}>
                                                      <div className="d-flex align-items-center gap-2 mb-3">
                                                        <div 
                                                          style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            borderRadius: '50%',
                                                            backgroundColor: '#223843',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'}}
                                                        >
                                                          <BsFunnelFill style={{ color: '#ffffff', fontSize: '16px' }} />
                                                        </div>
                                                        <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                          Filter by Course, Class & Student
                                                        </label>
                                                      </div>
                                                      <SelectableField
                                                        onSelect={handleSelect}
                                                        showCourse={true}
                                                        showClass={true}
                                                        showStudent={true}
                                                        abc={'abc'}
                                                        setData={noopSetData}
                                                        resetTrigger={resetKey}
                                                      />
                                                    </div>
                                                  </Col>
                                                )}



                                                </Row>
                                                </Card.Body> 

                                          
                                                          <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                                                            <Row className="g-3">
                                                              <Col xs={12}>
                                                                <div style={{ position: 'relative' }}>
                                                                  <div className="d-flex align-items-center gap-2 mb-3">
                                                                    <div
                                                                      style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#10B981',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'}}
                                                                    >
                                                                      <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                                                                    </div>
                                                                    <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                                      Search
                                                                    </label>
                                                                  </div>
                                                                  <div style={{ position: 'relative' }}>
                                                                    <BsSearch 
                                                                      style={{ 
                                                                        position: 'absolute', 
                                                                        left: '12px', 
                                                                        top: '50%', 
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#6b7280',
                                                                        fontSize: '16px',
                                                                        zIndex: 1}} 
                                                                    />
                                                                    <Form.Control
                                                                      type="text"
                                                                      placeholder="Search by Student Name"
                                                                      value={search}
                                                                      onChange={(e) => setSearch(e.target.value)}
                                                                      style={{
                                                                        paddingLeft: '40px',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #D1D3D4',
                                                                        fontSize: '14px',
                                                                        height: '40px',
                                                                        transition: 'all 0.2s ease',
                                                                        backgroundColor: '#ffffff',
                                                                        fontFamily: 'Inter, system-ui, sans-serif'}}
                                                                      onFocus={(e) => {
                                                                        e.target.style.borderColor = '#223843'
                                                                      }}
                                                                      onBlur={(e) => {
                                                                        e.target.style.borderColor = '#D1D3D4'
                                                                      }}
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </Col>
                                                            </Row>
                                                            
                                                          </Card.Body>
                                                          
                                                        </Card>
                                                        
                                                        
                                                      )}
                                                    </div>



          {/* Dedicated Add New button (matches AddStudent.js UX placement) */}

          {/* <div className="d-flex justify-content-end align-items-center mb-4">
           
              <button
                onClick={() => navigate('/CreateBus')}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <FaBus size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Transport
                </span>
              </button>
          </div> */}
           {/* Search */}
      

          <Card
            className="table-card"
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              overflow: 'visible',
              backgroundColor: '#ffffff',
              position: 'relative'}}
          >
            

      

      {/* Cards */}
      {loading ? (
        <p>Loading...</p>
      ) : filteredStudents.length > 0 ? (
       
        <div
              className="table-wrapper"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: '12px'}}
            >
              <Table
                className="table mb-0"
                style={{
                  borderRadius: '12px',
                  overflow: 'visible',
                  position: 'relative',
                  marginBottom: '0'}}
              >
                <Thead>
                  <Tr style={{ backgroundColor: '#F3F4F6' }}>
                    {[
                      
                      // 'Student ID',
                      'Admission Number',
                      'Name',
                      'Phone',
                      'Address',
                      // 'Institude ID',
                      "Assigned Vehicle No",
          
                      // 'Bus User',
                      // 'Status',
                      // 'Action',
                    ].map((h) => (
                      <Th
                        key={h}
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}
                      >
                        {h}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {currentStudents.length === 0 ? (
  <Tr>
    <Td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
      No students found
    </Td>
  </Tr>
) : (
                    currentStudents.map((r, index) => (
                    <Tr
                      key={r.id}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      {[
                          // r.id,
                          r.admission_number,
                          <span
    onClick={() => handleViewStudent(r.id)}
    style={{
      color: '#223843',
      fontWeight: '600',
      cursor: 'pointer',
      textDecoration: 'underline'
    }}
  >
    {r.name}
  </span>,
                          r.phone,
                          r.address,
                          // r.institute_id,
                          r.assign_bus,
                      ].map((val, i) => (
                        <Td
                          key={`${r.id}-${i}`}
                          style={{
                            fontSize: '14px',
                            padding: '16px',
                            border: 'none',
                            color: '#111827',
                            textAlign: 'left',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            whiteSpace: 'nowrap'}}
                        >
                          {val}
                        </Td>
                      ))}




                      

                    </Tr>
                  )))}
                </Tbody>
              </Table>
            </div>
      ) : (
        <div className="text-center mt-5">
          <LuGraduationCap size={60} />
          <h5>No Students Found</h5>
        </div>
      )}
    
          </Card>

          <TablePagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            totalItems={filteredStudents?.length || 0}
            className="d-flex justify-content-between align-items-center mb-3 mt-4"
            wrapperStyle={{ flexWrap: 'nowrap' }}
          />
          





 



        </Container>
      </div>
    </>
  )
}










































// import React, { useState, useEffect } from 'react'
// import { useParams, useNavigate } from 'react-router-dom'
// import { Card, Row, Col } from 'react-bootstrap'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// import { BASE_URL } from './commonComponents/ApiEndpoints'
// import { BsSearch, BsPersonFill } from 'react-icons/bs'
// import { LuGraduationCap } from 'react-icons/lu'
// import { useSidebar } from './SidebarContext'
// import ProfileDropdown from './commonComponents/ProfileDropdown'
// import { useAuth } from './AuthContext'
// import { useInstitute } from './commonComponents/InstituteContext'

// const ViewAssignedStudents = () => {
//   const { busId } = useParams()
//   const navigate = useNavigate()
//   const { logout } = useAuth()
//   const { isCollapsed } = useSidebar()
//   const { logo } = useInstitute()

//   const [students, setStudents] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [search, setSearch] = useState('')
//   const [marginLeft, setMarginLeft] = useState('0px')
//   const [logoError, setLogoError] = useState(false)

//   // Sidebar spacing
//   useEffect(() => {
//     const handleResize = () => {
//       const expandedWidth = 245
//       const collapsedWidth = 85
//       setMarginLeft(isCollapsed ? `${collapsedWidth}px` : `${expandedWidth}px`)
//     }
//     handleResize()
//   }, [isCollapsed])

//   // 🔥 Fetch Students by Bus API
//   useEffect(() => {
//     if (busId) fetchStudentsByBus()
//   }, [busId])

//   const fetchStudentsByBus = async () => {
//     setLoading(true)
//     try {
//       const instituteId = Cookies.get('institute_id')
//       const user = JSON.parse(Cookies.get('user') || '{}')

//       const response = await axios.get(
//         `${BASE_URL}/transport/${busId}/students`,
//         {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             'Institute-Id': Number(instituteId),
//           },
//         }
//       )

//       setStudents(response.data?.data || [])
//     } catch (error) {
//       console.error('Error fetching students:', error)
//       setStudents([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   // 🔍 Search filter
//   const filteredStudents = students.filter((student) =>
//     (student.name || '')
//       .toLowerCase()
//       .includes(search.toLowerCase())
//   )

//   return (
//     <div style={{ marginLeft, padding: '20px' }}>

//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <div className="d-flex align-items-center gap-3">

//           <div style={{
//             width: 40,
//             height: 40,
//             borderRadius: '50%',
//             overflow: 'hidden',
//             background: '#223843'
//           }}>
//             {!logoError ? (
//               <img
//                 src={logo}
//                 alt="logo"
//                 onError={() => setLogoError(true)}
//                 style={{ width: '100%', height: '100%' }}
//               />
//             ) : <LuGraduationCap color="white" />}
//           </div>

//           <h4 className="m-0 fw-bold">
//             Bus Assigned Students (Bus ID: {busId})
//           </h4>
//         </div>

//         <ProfileDropdown logout={logout} />
//       </div>

//       {/* Search */}
//       <input
//         type="text"
//         placeholder="Search student..."
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         className="form-control mb-3"
//       />

//       {/* Count */}
//       <p>
//         {loading
//           ? 'Loading...'
//           : `Total Students: ${filteredStudents.length}`}
//       </p>

//       {/* Cards */}
//       {loading ? (
//         <p>Loading...</p>
//       ) : filteredStudents.length > 0 ? (
//         <Row>
//           {filteredStudents.map((student, index) => (
//             <Col md={4} key={index} className="mb-4">
//               <Card style={{ borderRadius: '12px' }}>
//                 <Card.Body>

//                   <div className="d-flex align-items-center mb-3">
//                     <BsPersonFill size={30} />
//                     <div className="ms-3">
//                       <h5>{student.name || 'N/A'}</h5>
//                       <small>ID: {student.id}</small>
//                     </div>
//                   </div>

//                   <p><b>Bus ID:</b> {student.assign_bus}</p>
//                   <p><b>Institute:</b> {student.institute_id}</p>

//                   <button
//                     className="btn btn-dark w-100"
//                     onClick={() =>
//                       navigate(`/student/profile/${student.id}`)
//                     }
//                   >
//                     View Profile
//                   </button>

//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       ) : (
//         <div className="text-center mt-5">
//           <LuGraduationCap size={60} />
//           <h5>No Students Found</h5>
//         </div>
//       )}
//     </div>
//   )
// }

// export default ViewAssignedStudents







